import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Truck, Loader2 } from "lucide-react";

export default function Demo() {
  const { enterDemo } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      try {
        await enterDemo();
        navigate("/dashboard", { replace: true });
      } catch {
        setError(true);
      }
    })();
  }, [enterDemo, navigate]);

  return (
    <div data-testid="demo-loading" className="min-h-screen bg-slate-900 text-white flex flex-col items-center justify-center px-6 text-center">
      <div className="flex items-center gap-2 mb-6">
        <Truck size={26} />
        <span className="font-heading font-black text-xl tracking-tight">HAULCHECK</span>
      </div>
      {error ? (
        <>
          <p className="text-slate-300">Sorry — the demo couldn't be loaded just now.</p>
          <button onClick={() => window.location.reload()} className="mt-4 rounded-lg bg-emerald-500 px-5 py-2.5 font-bold hover:bg-emerald-400">Try again</button>
        </>
      ) : (
        <>
          <Loader2 size={28} className="animate-spin text-emerald-400" />
          <p className="mt-4 text-slate-300">Loading a live sample fleet — no signup needed…</p>
        </>
      )}
    </div>
  );
}
